import axios from "axios";

interface LoginResponse {
  success: boolean;
  message?: string;
  emailConfirmed?: boolean;
  phoneNumberConfirmed?: boolean;
  isActive?: boolean;
}

const login = async (email: string, password: string): Promise<LoginResponse> => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;
    const response = await axios.post(`${apiUrl}/login`, { email, password }, { withCredentials: true });

    if (response.status === 200) {
      const { emailConfirmed, phoneNumberConfirmed, isActive } = response.data;

      localStorage.setItem("isAuthenticated", "true");

      return { 
        success: true, 
        emailConfirmed, 
        phoneNumberConfirmed, 
        isActive 
      };
    }
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.detail || "Une erreur s'est produite lors de la connexion.",
    };
  }
  return { success: false, message: "Erreur de connexion" };
};

export default login;